/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateWaitingCategoryRequest } from '../models/create-waiting-category-request';
import { GenericResponse } from '../models/generic-response';
import { GetWaitingCategoryResponse } from '../models/get-waiting-category-response';
import { UpdateWaitingCategoryRequest } from '../models/update-waiting-category-request';
import { WaitingCategoryResponse } from '../models/waiting-category-response';

/**
 * Waiting category master APIs
 */
@Injectable({ providedIn: 'root' })
export class WaitingCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllWaitingCategory()` */
  static readonly GetAllWaitingCategoryPath = '/api/v1/waiting-categories';

  /**
   * Get list of waiting categorys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllWaitingCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllWaitingCategory$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search waiting category name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetWaitingCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WaitingCategoryService.GetAllWaitingCategoryPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetWaitingCategoryResponse>;
        })
      );
  }

  /**
   * Get list of waiting categorys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllWaitingCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllWaitingCategory(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search waiting category name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetWaitingCategoryResponse> {
    return this.getAllWaitingCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetWaitingCategoryResponse>
        ): GetWaitingCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `createWaitingCategory()` */
  static readonly CreateWaitingCategoryPath = '/api/v1/waiting-categories';

  /**
   * Create waiting category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWaitingCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWaitingCategory$Response(
    params: {
      body: CreateWaitingCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WaitingCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WaitingCategoryService.CreateWaitingCategoryPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WaitingCategoryResponse>;
        })
      );
  }

  /**
   * Create waiting category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWaitingCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWaitingCategory(
    params: {
      body: CreateWaitingCategoryRequest;
    },
    context?: HttpContext
  ): Observable<WaitingCategoryResponse> {
    return this.createWaitingCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WaitingCategoryResponse>
        ): WaitingCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `getWaitingCategoryById()` */
  static readonly GetWaitingCategoryByIdPath =
    '/api/v1/waiting-categories/{id}';

  /**
   * Get waiting category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingCategoryById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WaitingCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WaitingCategoryService.GetWaitingCategoryByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WaitingCategoryResponse>;
        })
      );
  }

  /**
   * Get waiting category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWaitingCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingCategoryById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WaitingCategoryResponse> {
    return this.getWaitingCategoryById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WaitingCategoryResponse>
        ): WaitingCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteWaitingCategory()` */
  static readonly DeleteWaitingCategoryPath = '/api/v1/waiting-categories/{id}';

  /**
   * Delete waiting category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWaitingCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWaitingCategory$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WaitingCategoryService.DeleteWaitingCategoryPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete waiting category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWaitingCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWaitingCategory(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteWaitingCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateWaitingCategory()` */
  static readonly UpdateWaitingCategoryPath = '/api/v1/waiting-categories/{id}';

  /**
   * Update waiting category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWaitingCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWaitingCategory$Response(
    params: {
      id: number;
      body: UpdateWaitingCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WaitingCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WaitingCategoryService.UpdateWaitingCategoryPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WaitingCategoryResponse>;
        })
      );
  }

  /**
   * Update waiting category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWaitingCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWaitingCategory(
    params: {
      id: number;
      body: UpdateWaitingCategoryRequest;
    },
    context?: HttpContext
  ): Observable<WaitingCategoryResponse> {
    return this.updateWaitingCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WaitingCategoryResponse>
        ): WaitingCategoryResponse => r.body
      )
    );
  }
}
